module.exports = __webpack_public_path__ + "static/media/rosemax-icon-button.dbcb99f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/rosemax-icon-button.png
// module id = 1124
// module chunks = 4